export default "__VITE_ASSET__Bcf0VzMM__"